import firebase from "firebase";

const config = {
  apiKey: "AIzaSyDvh1XlbECNNAAWbfPCHzn0scGWof9GrkQ",
  authDomain: "pointageapp-8a0e9.firebaseapp.com",
  databaseURL:
    "https://pointageapp-8a0e9-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "pointageapp-8a0e9",
  storageBucket: "pointageapp-8a0e9.appspot.com",
  messagingSenderId: "532471681575",
  appId: "1:532471681575:web:e2821c5591ad3e3d33b402",
};

const firebaseApp = firebase.initializeApp(config);

export default firebaseApp.database();
